exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dt-df{display:inline-block;width:100%;overflow:auto;position:relative}.dt-df-search{float:left;width:100%;padding-right:60px}.dt-df-pagination{position:absolute;width:60px;float:right;right:0;top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-32916177!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DataTableDefaultFilter.vue
// module id = 866
// module chunks = 2